export const LicenseConstants = {
  STATE_UNCHECKED: "UNCHECKED",
  STATE_VALID: "VALID",
  STATE_INVALID: "INVALID",

  UPLOAD_LICENSE_REQUEST: "UPLOAD_LICENSE_REQUEST",
  UPLOAD_LICENSE_SUCCESS: "UPLOAD_LICENSE_SUCCESS",
  UPLOAD_LICENSE_FAILURE: "UPLOAD_LICENSE_FAILURE",
};
